import React, { Fragment, Suspense, useEffect } from "react";
import Preloader from "../elements/Preloader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { base_url } from "./Constants";
import { fetchHomePageData } from "../redux/stateSlice/homePageSlice";
import TestimonialOne from "../components/TestimonialOne";
const AboutOne = React.lazy(() => import("../components/AboutOne"));
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const CounterOne = React.lazy(() => import("../components/CounterOne"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const PartnerOne = React.lazy(() => import("../components/PartnerOne"));
const SkillOne = React.lazy(() => import("../components/SkillOne"));
const TeamOne = React.lazy(() => import("../components/TeamOne"));
const TestimonialTwo = React.lazy(() => import("../components/TestimonialTwo"));
const VideoAreaOne = React.lazy(() => import("../components/VideoAreaOne"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const About = () => {
  const {t,in18} = useTranslation();
  
  const setting  =  useSelector(state=>state.settingData.data);
  const { data, loading, error } = useSelector((state) => state.homePage);
  const dispatch =  useDispatch(); 
  
  useEffect(() => {
    if (loading === false ) {
      dispatch(fetchHomePageData());
    }
  }, [dispatch]);

  return (
    <>
      <Fragment>
        
          <Suspense fallback={<Preloader />}>
            {/* Search Popup */}
            <SearchPopup />

            {/* Navbar One */}
            <NavbarOne title={t("about us")} />
  
            {/* Breadcrumb */} 
            {setting && <Breadcrumb title={t("about us")} header_bg={base_url+'/'+setting.about_bg} />}
            
              {/* About One */}
            <div className='pd-top-120 pd-bottom-120'>
              <AboutOne />
            </div>

            {/* Counter One */}

            <div className='fact-area' style={{ background: "#f9f9f9" }}>
              <CounterOne />
            </div>

            {/* Skill One */}
            <SkillOne />

            {/* Video Area One */}
            <VideoAreaOne />

          

            {/* Testimonial One */}
            
            <TestimonialOne />

            {/* Partner One */}
            <PartnerOne />

            {/* Footer One */}
            <FooterOne />

            {/* Footer Bottom One */}
            <FooterBottomOne />
            
          </Suspense>
      </Fragment>
    </>
  );
};

export default About;
